import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useSaleListModel } from "../saleListModel";

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useSaleListModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "外贸合同号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "贸易国别",
            fieldName: "countryCode",
            options: getSelectedDictOne(DictCodeEnmu.COUNTRY)
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户名称",
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "币种",
            fieldName: "currencyCode",
            options: getSelectedDictOne(DictCodeEnmu.CURRENCY)
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["制单起始日期", "制单结束日期"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        }
    ]

    return (
        <YhPageHeader
            title="外贸合同查询列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}